module.exports = EntryVideoLegacy;